import { inject } from '@angular/core';
import { RedirectFunction, Router, Routes } from '@angular/router';
import { authGuard } from './core/guards/auth/auth-guard';
import { profileGuard } from './core/guards/profile/profile-guard';
import { AuthService } from './core/services/auth/auth.service';
import { TYPE_USER_ENUM } from './shared/enums/type-user.enum';
import { NotFoundComponent } from './core/components/not-found/not-found.component';
import { HomeComponent } from './module/home/home.component';
import { EventFilterComponent } from './module/events/pages/event-filter/event-filter.component';

export const redirectLegacyTicketsToProfile: RedirectFunction = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return router.createUrlTree(['/perfil'], {
    queryParams: authService.isCustomer() ? { tab: 2 } : {},
  });
};

export const routes: Routes = [
  // ========================================
  // Rotas da Aplicação
  // ========================================
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'filter',
    component: EventFilterComponent,
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./module/auth/auth.routes').then((m) => m.routes),
  },
  {
    path: 'eventos',
    loadChildren: () =>
      import('./module/events/events.routes').then((m) => m.routes),
  },
  {
    path: 'perfil',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./module/profile/profile.routes').then(
        (m) => m.PROFILE_ROUTES
      ),
  },
  {
    path: 'ingressos',
    redirectTo: redirectLegacyTicketsToProfile,
  },
  {
    path: 'configuracoes',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./module/config/config.module').then((m) => m.routes),
  },
  {
    path: 'relatorios',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./module/reports/reports.routes').then((m) => m.routes),
  },
  {
    path: 'relatorios-financeiros',
    canActivate: [authGuard, profileGuard],
    data: { profileList: [TYPE_USER_ENUM.ADMIN] },
    loadComponent: () =>
      import('./module/reports/pages/admin-financial-transactions-page/admin-financial-transactions-page.component')
        .then((m) => m.AdminFinancialTransactionsPageComponent),
  },
  {
    path: 'formularios',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./module/forms/forms.routes').then((m) => m.routes),
  },
  {
    path: 'colaborador',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./module/colaborator/colaborator/colaborator.component').then(
        (m) => m.ColaboratorComponent
      ),
  },
  {
    path: 'usuarios',
    canActivate: [authGuard, profileGuard],
    data: { profileList: [TYPE_USER_ENUM.ADMIN] },
    loadChildren: () =>
      import('./module/users/users.module').then((m) => m.routes),
  },
  {
    path: 'oferta',
    loadComponent: () =>
      import('./module/oferta/pages/oferta-page/oferta-page.component').then(
        (m) => m.OfertaPageComponent
      ),
  },
  {
    path: 'organizador/:slug',
    loadComponent: () =>
      import('./module/organizer-public/organizer-events-page.component').then(
        (m) => m.OrganizerEventsPageComponent
      ),
  },
  {
    path: 'termos-de-uso',
    loadComponent: () =>
      import('./module/config/pages/institutional-page/institutional-page.component').then(
        (m) => m.InstitutionalPageComponent
      ),
    data: { document: 'terms' },
  },
  {
    path: 'politica-de-privacidade',
    loadComponent: () =>
      import('./module/config/pages/institutional-page/institutional-page.component').then(
        (m) => m.InstitutionalPageComponent
      ),
    data: { document: 'privacy' },
  },
  {
    path: 'quem-somos',
    loadComponent: () =>
      import('./module/config/pages/institutional-page/institutional-page.component').then(
        (m) => m.InstitutionalPageComponent
      ),
    data: { document: 'about' },
  },

  // ========================================
  // Rotas Padrão e 404
  // ========================================
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: '404',
    component: NotFoundComponent
  },
  {
    path: '**',
    component: NotFoundComponent
  },
];
